<template>
  <div id="app">
    <router-view />
    <auth-sidebar />
    <notebook-sidebar />
    <privacy-policy-modal />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import InformationNavigation from '@/components/Header/InformationNavigation.vue';
import PagesNavigation from '@/components/Header/PagesNavigation.vue';
import RightSidebar from '@/components/RightSidebar.vue';
import AuthSidebar from '@/components/Authorization/AuthSidebar.vue';
import NotebookSidebar from '@/components/Notebook/NotebookSidebar.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import PrivacyPolicyModal from '@/components/Core/PrivacyPolicyModal.vue';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';

@Component({
  metaInfo(this: any): any {
    return {
      title: this.pageTitle,
    };
  },
  components: {
    InformationNavigation,
    PagesNavigation,
    RightSidebar,
    FooterComponent,
    AuthSidebar,
    PrivacyPolicyModal,
    NotebookSidebar,
  },
})
export default class App extends Vue {
  get sid() {
    return AppModule.sid;
  }

  get languageSid() {
    return AppModule.languageSid;
  }

  get pageTitle() {
    return AppModule.setting.html_title;
  }

  async created() {
    const loadTranslation = AppModule.getTranslation();
    const loadTranslationText = AppModule.getTranslationText();
    await Promise.all([loadTranslation, loadTranslationText]);
    await AppModule.getSettingPortal({ sid: this.languageSid });
    await AppModule.getSetting({ sid: this.languageSid });
    await AppModule.getJobCountPortal({ sid: this.languageSid });

    if (UserModule.accessTokenApplicant) {
      if (!UserModule.userInfoApplicant) {
        await UserModule.GetUserInfoApplicant();
      }
    }
    if (UserModule.accessTokenConsultant) {
      if (!UserModule.userInfoConsultant) {
        await UserModule.GetUserInfoConsultant();
      }
    }
    if (UserModule.accessTokenCompany) {
      if (!UserModule.userInfoCompany) {
        await UserModule.GetUserInfoCompany();
      }
    }
  }
}
</script>
